import { Injectable, OnInit, OnDestroy } from '@angular/core';
import { WebsocketService } from './websocket.service';
import { Observable, Subject, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppService } from './app.service';

import { WSMessage } from '../_interfaces/ws-message.interface';

@Injectable({
  providedIn: 'root',
})
export class ServerMessagesService implements OnInit, OnDestroy {

  messages: Observable<any> = new Observable();
  messagesSub: any;
  messages$: Observable<any>;

  constructor(
    public wsService: WebsocketService,
    private appSvc: AppService,
  ) {
    this.connect();
  }

  ngOnInit() {
  }

  connect() {

    if (!localStorage.getItem('api_key')) {
      setTimeout(() => {
        this.connect();
      }, 60000);
      return;
    }

    this.messages = this.wsService
      .connect();

    if (!this.messages) {
      // console.log(this.messages);
      setTimeout(() => {
        this.connect();
      }, 5000);
      return;
    }

    this.messages.pipe(
        map((response: any): any => {
          return response;
        })
      );
    // this.messages = of(wsService
    //   .connect())
    //   .pipe(
    //     map((response: any): any => {
    //       return response;
    //     })
    //   ) as Observable<any>;
    // this.messages$ = this.messages.asObservable();
    // this.messages$ = this.messages;
    this.messagesSub = this.messages.subscribe((msg: any) => {
      this.parseResponse(msg);
    });

  }

  ngOnDestroy() {
    this.messagesSub.unsubscribe();
  }

  /**
   * Our simplified interface for sending
   * messages back to our socket.io server
   */
  sendMsg(msg: WSMessage) {

    this.wsService.sendMessage(msg);

  }

  parseResponse(response: WSMessage) {

    // console.log('WS:', response);

    if (typeof response.result !== 'undefined' && !response.result) {
      console.error('NOT LOGGED?????');
    }

    switch (response.action) {
      // case 'invalidar_orden': {
      case 'notif': {
        this.appSvc.addNotif(response.data);
        // console.log('adding notif?');
        break;
      }
      default: {
        break;
      }
    }

  }

}

